module.exports = {"header":{"material":"Material","special":"Special","assambly":"Assambly"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/header.json
// module id = 537
// module chunks = 14